import type * as Types from '../../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GuestEventHotelRoomBlocksQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GuestEventHotelRoomBlocksQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    travelSettings?: {
      __typename?: 'TravelSettings';
      currencyCode?: Types.TravelCurrencyCode | null;
      accommodationsPageLayout?: Types.AccommodationsPageLayout | null;
      accommodationsNeighborhoodsNote?: string | null;
      checkInDate?: string | null;
      checkOutDate?: string | null;
    } | null;
    info: { __typename?: 'EventInfo'; id: string; timezone?: string | null };
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    accommodationPlacesV2: Array<{
      __typename?: 'AccommodationPlaceV2';
      id: string;
      type?: Types.AccommodationPlaceType | null;
      isFavorite?: boolean | null;
      isGuestFavorite?: boolean | null;
      userNote?: string | null;
      name?: string | null;
      description?: string | null;
      address?: string | null;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
      starRating?: number | null;
      country?: string | null;
      email?: string | null;
      phone?: string | null;
      url?: string | null;
      lat?: number | null;
      long?: number | null;
      isPhotoHidden?: boolean | null;
      zhId?: string | null;
      googlePlaceId?: string | null;
      customName?: string | null;
      customAddress?: string | null;
      customUrl?: string | null;
      customPhone?: string | null;
      createdByType: string;
      isFromAccommodationCatalog: boolean;
      isHostStayingHere?: boolean | null;
      joyPlaceId?: string | null;
      isCustomLinkEnabled?: boolean | null;
      photo?: { __typename?: 'Photo'; id: string; url: string } | null;
      customPhoto?: { __typename?: 'Photo'; id: string; url: string } | null;
      accommodationRoomBlock?: {
        __typename?: 'AccommodationPlaceRoomBlock';
        bookingUrl: string;
        checkInDate: string;
        checkOutDate: string;
        cutoffDate: string;
        isJoyManagedRoomBlock: boolean;
        numberOfRoomsReserved: number;
        status: Types.AccommodationPlaceRoomBlockStatus;
        pricePerNight?: number | null;
        strikeoutPricePerNight?: number | null;
      } | null;
      distances?: {
        __typename?: 'TravelDistancesBetweenPointsResponse';
        commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints'; durationMinutes?: number | null; km: number; mi: number; type: Types.DistancesBetweenPointsType }>;
      } | null;
    }>;
  } | null;
};

export type AccommodationPagePricingQueryVariables = Types.Exact<{
  payload: Types.TravelPricingsForAccommodationByPropertyIdPayload;
}>;

export type AccommodationPagePricingQuery = {
  __typename?: 'Query';
  travelPricingsForAccommodationByPropertyId: {
    __typename?: 'TravelPricingsByPropertyIdResult';
    pricings: Array<{
      __typename: 'TravelPricingByPropertyIdItem';
      property: { __typename: 'AccommodationCatalogProperty'; joyPlaceId: string };
      pricingData?: {
        __typename: 'TravelPricingByPropertyIdData';
        perNightOriginalAmountBeforeTaxesAndFees?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        perNightFinalAmountBeforeTaxesAndFees?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        originalAmount?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
      } | null;
    }>;
  };
};

export type EventConfirmedHotelBookingCountQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type EventConfirmedHotelBookingCountQuery = { __typename?: 'Query'; eventConfirmedHotelBookingCount: number };

export type PricingByPropertyIdFragment = {
  __typename: 'TravelPricingByPropertyIdItem';
  property: { __typename: 'AccommodationCatalogProperty'; joyPlaceId: string };
  pricingData?: {
    __typename: 'TravelPricingByPropertyIdData';
    perNightOriginalAmountBeforeTaxesAndFees?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    perNightFinalAmountBeforeTaxesAndFees?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    originalAmount?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
  } | null;
};

export type TravelPlacesPricingAndBookingDetailsQueryVariables = Types.Exact<{
  payload: Types.TravelPlacePricingAndBookingDetailsPayload;
}>;

export type TravelPlacesPricingAndBookingDetailsQuery = {
  __typename?: 'Query';
  travelPlacesPricingAndBookingDetails: {
    __typename?: 'TravelPlacePricingAndBookingDetailsResult';
    accommodationPlaces: Array<{
      __typename: 'AccommodationPlacePricingAndBookingDetails';
      isDirectBooking: boolean;
      accommodationPlace: {
        __typename: 'AccommodationPlaceV2';
        id: string;
        lat?: number | null;
        long?: number | null;
        googlePlaceId?: string | null;
        joyPlaceId?: string | null;
        name?: string | null;
        address?: string | null;
        zhId?: string | null;
        url?: string | null;
        customUrl?: string | null;
        starRating?: number | null;
        photo?: { __typename?: 'Photo'; id: string; url: string } | null;
      };
      pricingInfo?: {
        __typename?: 'PricingForAccommodationPlace';
        strikeoutRateProvider?: Types.StrikeoutRateProvider | null;
        refundability?: Types.TravelOfferRefundability | null;
        _diag?: any | null;
        baseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
        nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
        perNightPerOccupancyBaseAmount?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        nightlyTotalRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
        strikeoutBaseRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        strikeoutNightlyBaseRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        perNightPerOccupancyStrikeoutBaseAmount?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        strikeoutNightlyTotalRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        strikeoutTotalRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        totalRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
        cancellationPolicies?: Array<{
          __typename?: 'TravelOfferCancellationPolicyRule';
          start: string;
          end?: string | null;
          estimatedCancellationAmount?: {
            __typename?: 'TravelOfferEstimatedCancellationAmount';
            valueType: Types.TravelOfferCancellationPolicyRuleValueType;
            amount: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
          } | null;
        }> | null;
        bufferedCancellationPolicies?: Array<{
          __typename?: 'TravelOfferCancellationPolicyRule';
          start: string;
          end?: string | null;
          estimatedCancellationAmount?: { __typename?: 'TravelOfferEstimatedCancellationAmount'; amount: { __typename?: 'TravelMonetaryValue'; valueInMinorUnits: number } } | null;
          estimatedFeeAmount?: { __typename?: 'TravelMonetaryValue'; valueInMinorUnits: number } | null;
        }> | null;
      } | null;
      redirectMechanisms?: Array<{
        __typename: 'RedirectMechanism';
        telemetryDestinationName: string;
        trackingQueryStringKey?: Types.TrackingQueryStringKey | null;
        type: Types.RedirectMechanismType;
        url: string;
        travelOfferProvider?: Types.TravelOfferProvider | null;
      }> | null;
    }>;
    joyPlaces: Array<{
      __typename: 'JoyPlacePricingAndBookingDetails';
      isDirectBooking: boolean;
      joyPlace: {
        __typename: 'JoyPlace';
        id: string;
        lat?: number | null;
        long?: number | null;
        googlePlaceId?: string | null;
        name?: string | null;
        address?: string | null;
        zhId?: string | null;
        url?: string | null;
      };
      pricingInfo?: {
        __typename: 'PricingForAccommodationPlace';
        nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
        perNightPerOccupancyBaseAmount?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        strikeoutNightlyBaseRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        perNightPerOccupancyStrikeoutBaseAmount?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        totalRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
      } | null;
      redirectMechanisms?: Array<{
        __typename: 'RedirectMechanism';
        telemetryDestinationName: string;
        trackingQueryStringKey?: Types.TrackingQueryStringKey | null;
        type: Types.RedirectMechanismType;
        url: string;
        travelOfferProvider?: Types.TravelOfferProvider | null;
      }> | null;
    }>;
  };
};

export type TravelPlacePricingAndBookingDetailsFragment = {
  __typename: 'AccommodationPlacePricingAndBookingDetails';
  isDirectBooking: boolean;
  accommodationPlace: {
    __typename: 'AccommodationPlaceV2';
    id: string;
    lat?: number | null;
    long?: number | null;
    googlePlaceId?: string | null;
    joyPlaceId?: string | null;
    name?: string | null;
    address?: string | null;
    zhId?: string | null;
    url?: string | null;
    customUrl?: string | null;
    starRating?: number | null;
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
  };
  pricingInfo?: {
    __typename?: 'PricingForAccommodationPlace';
    strikeoutRateProvider?: Types.StrikeoutRateProvider | null;
    refundability?: Types.TravelOfferRefundability | null;
    _diag?: any | null;
    baseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
    nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
    perNightPerOccupancyBaseAmount?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    nightlyTotalRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
    strikeoutBaseRate?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    strikeoutNightlyBaseRate?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    perNightPerOccupancyStrikeoutBaseAmount?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    strikeoutNightlyTotalRate?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    strikeoutTotalRate?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    totalRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
    cancellationPolicies?: Array<{
      __typename?: 'TravelOfferCancellationPolicyRule';
      start: string;
      end?: string | null;
      estimatedCancellationAmount?: {
        __typename?: 'TravelOfferEstimatedCancellationAmount';
        valueType: Types.TravelOfferCancellationPolicyRuleValueType;
        amount: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
      } | null;
    }> | null;
    bufferedCancellationPolicies?: Array<{
      __typename?: 'TravelOfferCancellationPolicyRule';
      start: string;
      end?: string | null;
      estimatedCancellationAmount?: { __typename?: 'TravelOfferEstimatedCancellationAmount'; amount: { __typename?: 'TravelMonetaryValue'; valueInMinorUnits: number } } | null;
      estimatedFeeAmount?: { __typename?: 'TravelMonetaryValue'; valueInMinorUnits: number } | null;
    }> | null;
  } | null;
  redirectMechanisms?: Array<{
    __typename: 'RedirectMechanism';
    telemetryDestinationName: string;
    trackingQueryStringKey?: Types.TrackingQueryStringKey | null;
    type: Types.RedirectMechanismType;
    url: string;
    travelOfferProvider?: Types.TravelOfferProvider | null;
  }> | null;
};

export type TravelJoyPlacePricingAndBookingDetailsFragment = {
  __typename: 'JoyPlacePricingAndBookingDetails';
  isDirectBooking: boolean;
  joyPlace: {
    __typename: 'JoyPlace';
    id: string;
    lat?: number | null;
    long?: number | null;
    googlePlaceId?: string | null;
    name?: string | null;
    address?: string | null;
    zhId?: string | null;
    url?: string | null;
  };
  pricingInfo?: {
    __typename: 'PricingForAccommodationPlace';
    nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
    perNightPerOccupancyBaseAmount?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    strikeoutNightlyBaseRate?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    perNightPerOccupancyStrikeoutBaseAmount?: {
      __typename?: 'TravelMonetaryValue';
      currency: Types.TravelCurrencyCode;
      digits: number;
      floatingPointDecimalString: string;
      valueInMinorUnits: number;
    } | null;
    totalRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
  } | null;
  redirectMechanisms?: Array<{
    __typename: 'RedirectMechanism';
    telemetryDestinationName: string;
    trackingQueryStringKey?: Types.TrackingQueryStringKey | null;
    type: Types.RedirectMechanismType;
    url: string;
    travelOfferProvider?: Types.TravelOfferProvider | null;
  }> | null;
};

export type IncrementInterestedGuestCountMutationVariables = Types.Exact<{
  reservedRoomBlockId: Types.Scalars['ID'];
}>;

export type IncrementInterestedGuestCountMutation = { __typename?: 'Mutation'; incrementInterestedGuestCount?: any | null };

export type TravelReservationSummariesByPropertyIdentifiersQueryVariables = Types.Exact<{
  payload: Types.TravelReservationSummariesByPropertyIdentifiersPayload;
}>;

export type TravelReservationSummariesByPropertyIdentifiersQuery = {
  __typename?: 'Query';
  travelReservationSummariesByPropertyIdentifiers?: {
    __typename?: 'TravelReservationSummariesByPropertyIdentifiersResult';
    reservationSummaries?: Array<{
      __typename?: 'TravelReservationsSummary';
      reservationsCount?: number | null;
      identifier: { __typename?: 'AccommodationCatalogPropertyIdentifier'; id: string; type: Types.AccommodationCatalogPropertyIdentifierV2Type };
    }> | null;
  } | null;
};

export type TravelRateComparisonsForTravelPlacesQueryVariables = Types.Exact<{
  payload: Types.ComparisonsForTravelPlaceIdPayload;
}>;

export type TravelRateComparisonsForTravelPlacesQuery = {
  __typename?: 'Query';
  travelRateComparisonsForTravelPlaces: Array<{
    __typename?: 'TravelPlaceComparison';
    joyPlaceId: string;
    id: string;
    providers: Array<{
      __typename?: 'TravelPlaceComparisonForProvider';
      providerFQDN: string;
      providerSearchURL: string;
      nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; valueInMinorUnits: number; floatingPointDecimalString: string; digits: number };
    }>;
  }>;
};

export type PriceComparisonFragment = {
  __typename?: 'TravelPlaceComparison';
  joyPlaceId: string;
  id: string;
  providers: Array<{
    __typename?: 'TravelPlaceComparisonForProvider';
    providerFQDN: string;
    providerSearchURL: string;
    nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; valueInMinorUnits: number; floatingPointDecimalString: string; digits: number };
  }>;
};

export const PricingByPropertyIdFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PricingByPropertyId' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelPricingByPropertyIdItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'property' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricingData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightOriginalAmountBeforeTaxesAndFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightFinalAmountBeforeTaxesAndFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TravelPlacePricingAndBookingDetailsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelPlacePricingAndBookingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlacePricingAndBookingDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDirectBooking' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationPlace' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zhId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricingInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'baseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutNightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyStrikeoutBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutNightlyTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'strikeoutRateProvider' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cancellationPolicies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bufferedCancellationPolicies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } }] },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedFeeAmount' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } }] },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'refundability' } },
                { kind: 'Field', name: { kind: 'Name', value: '_diag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectMechanisms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telemetryDestinationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingQueryStringKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'travelOfferProvider' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TravelJoyPlacePricingAndBookingDetailsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelJoyPlacePricingAndBookingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JoyPlacePricingAndBookingDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDirectBooking' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'joyPlace' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zhId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricingInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutNightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyStrikeoutBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectMechanisms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telemetryDestinationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingQueryStringKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'travelOfferProvider' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PriceComparisonFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PriceComparison' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelPlaceComparison' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'providers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'providerFQDN' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerSearchURL' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuestEventHotelRoomBlocksDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GuestEventHotelRoomBlocks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accommodationsPageLayout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accommodationsNeighborhoodsNote' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accommodationPlacesV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFavorite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isGuestFavorite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userNote' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPhotoHidden' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zhId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customPhoto' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'customName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdByType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accommodationRoomBlock' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationRoomBlock' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFromAccommodationCatalog' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isHostStayingHere' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCustomLinkEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'distances' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationRoomBlock' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlaceRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bookingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cutoffDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJoyManagedRoomBlock' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRoomsReserved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricePerNight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'strikeoutPricePerNight' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistancesBetweenPointsResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commonDistance' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelDistanceBetweenPoints' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'km' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mi' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGuestEventHotelRoomBlocksQuery__
 *
 * To run a query within a React component, call `useGuestEventHotelRoomBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestEventHotelRoomBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestEventHotelRoomBlocksQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGuestEventHotelRoomBlocksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>) {
  return ApolloReactHooks.useQuery<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>(GuestEventHotelRoomBlocksDocument, baseOptions);
}
export function useGuestEventHotelRoomBlocksLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>(GuestEventHotelRoomBlocksDocument, baseOptions);
}
export type GuestEventHotelRoomBlocksQueryHookResult = ReturnType<typeof useGuestEventHotelRoomBlocksQuery>;
export type GuestEventHotelRoomBlocksLazyQueryHookResult = ReturnType<typeof useGuestEventHotelRoomBlocksLazyQuery>;
export type GuestEventHotelRoomBlocksQueryResult = Apollo.QueryResult<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>;
export const AccommodationPagePricingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationPagePricing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelPricingsForAccommodationByPropertyIdPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelPricingsForAccommodationByPropertyId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pricings' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PricingByPropertyId' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PricingByPropertyId' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelPricingByPropertyIdItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'property' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricingData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightOriginalAmountBeforeTaxesAndFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightFinalAmountBeforeTaxesAndFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationPagePricingQuery__
 *
 * To run a query within a React component, call `useAccommodationPagePricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationPagePricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationPagePricingQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationPagePricingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>) {
  return ApolloReactHooks.useQuery<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>(AccommodationPagePricingDocument, baseOptions);
}
export function useAccommodationPagePricingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>(AccommodationPagePricingDocument, baseOptions);
}
export type AccommodationPagePricingQueryHookResult = ReturnType<typeof useAccommodationPagePricingQuery>;
export type AccommodationPagePricingLazyQueryHookResult = ReturnType<typeof useAccommodationPagePricingLazyQuery>;
export type AccommodationPagePricingQueryResult = Apollo.QueryResult<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>;
export const EventConfirmedHotelBookingCountDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventConfirmedHotelBookingCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventConfirmedHotelBookingCount' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventConfirmedHotelBookingCountQuery__
 *
 * To run a query within a React component, call `useEventConfirmedHotelBookingCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventConfirmedHotelBookingCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventConfirmedHotelBookingCountQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventConfirmedHotelBookingCountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<EventConfirmedHotelBookingCountQuery, EventConfirmedHotelBookingCountQueryVariables>,
) {
  return ApolloReactHooks.useQuery<EventConfirmedHotelBookingCountQuery, EventConfirmedHotelBookingCountQueryVariables>(EventConfirmedHotelBookingCountDocument, baseOptions);
}
export function useEventConfirmedHotelBookingCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventConfirmedHotelBookingCountQuery, EventConfirmedHotelBookingCountQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<EventConfirmedHotelBookingCountQuery, EventConfirmedHotelBookingCountQueryVariables>(EventConfirmedHotelBookingCountDocument, baseOptions);
}
export type EventConfirmedHotelBookingCountQueryHookResult = ReturnType<typeof useEventConfirmedHotelBookingCountQuery>;
export type EventConfirmedHotelBookingCountLazyQueryHookResult = ReturnType<typeof useEventConfirmedHotelBookingCountLazyQuery>;
export type EventConfirmedHotelBookingCountQueryResult = Apollo.QueryResult<EventConfirmedHotelBookingCountQuery, EventConfirmedHotelBookingCountQueryVariables>;
export const TravelPlacesPricingAndBookingDetailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TravelPlacesPricingAndBookingDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelPlacePricingAndBookingDetailsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelPlacesPricingAndBookingDetails' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accommodationPlaces' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelPlacePricingAndBookingDetails' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'joyPlaces' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelJoyPlacePricingAndBookingDetails' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelPlacePricingAndBookingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlacePricingAndBookingDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDirectBooking' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationPlace' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zhId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricingInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'baseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutNightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyStrikeoutBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutNightlyTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'strikeoutRateProvider' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cancellationPolicies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bufferedCancellationPolicies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } }] },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedFeeAmount' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } }] },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'refundability' } },
                { kind: 'Field', name: { kind: 'Name', value: '_diag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectMechanisms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telemetryDestinationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingQueryStringKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'travelOfferProvider' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelJoyPlacePricingAndBookingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JoyPlacePricingAndBookingDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDirectBooking' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'joyPlace' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zhId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricingInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutNightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyStrikeoutBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectMechanisms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telemetryDestinationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingQueryStringKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'travelOfferProvider' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTravelPlacesPricingAndBookingDetailsQuery__
 *
 * To run a query within a React component, call `useTravelPlacesPricingAndBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelPlacesPricingAndBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelPlacesPricingAndBookingDetailsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelPlacesPricingAndBookingDetailsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>(
    TravelPlacesPricingAndBookingDetailsDocument,
    baseOptions,
  );
}
export function useTravelPlacesPricingAndBookingDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>(
    TravelPlacesPricingAndBookingDetailsDocument,
    baseOptions,
  );
}
export type TravelPlacesPricingAndBookingDetailsQueryHookResult = ReturnType<typeof useTravelPlacesPricingAndBookingDetailsQuery>;
export type TravelPlacesPricingAndBookingDetailsLazyQueryHookResult = ReturnType<typeof useTravelPlacesPricingAndBookingDetailsLazyQuery>;
export type TravelPlacesPricingAndBookingDetailsQueryResult = Apollo.QueryResult<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>;
export const IncrementInterestedGuestCountDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IncrementInterestedGuestCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reservedRoomBlockId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'incrementInterestedGuestCount' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'reservedRoomBlockId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'reservedRoomBlockId' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type IncrementInterestedGuestCountMutationFn = Apollo.MutationFunction<IncrementInterestedGuestCountMutation, IncrementInterestedGuestCountMutationVariables>;

/**
 * __useIncrementInterestedGuestCountMutation__
 *
 * To run a mutation, you first call `useIncrementInterestedGuestCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementInterestedGuestCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementInterestedGuestCountMutation, { data, loading, error }] = useIncrementInterestedGuestCountMutation({
 *   variables: {
 *      reservedRoomBlockId: // value for 'reservedRoomBlockId'
 *   },
 * });
 */
export function useIncrementInterestedGuestCountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<IncrementInterestedGuestCountMutation, IncrementInterestedGuestCountMutationVariables>,
) {
  return ApolloReactHooks.useMutation<IncrementInterestedGuestCountMutation, IncrementInterestedGuestCountMutationVariables>(IncrementInterestedGuestCountDocument, baseOptions);
}
export type IncrementInterestedGuestCountMutationHookResult = ReturnType<typeof useIncrementInterestedGuestCountMutation>;
export type IncrementInterestedGuestCountMutationResult = Apollo.MutationResult<IncrementInterestedGuestCountMutation>;
export type IncrementInterestedGuestCountMutationOptions = Apollo.BaseMutationOptions<IncrementInterestedGuestCountMutation, IncrementInterestedGuestCountMutationVariables>;
export const TravelReservationSummariesByPropertyIdentifiersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TravelReservationSummariesByPropertyIdentifiers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelReservationSummariesByPropertyIdentifiersPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelReservationSummariesByPropertyIdentifiers' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reservationSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identifier' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reservationsCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTravelReservationSummariesByPropertyIdentifiersQuery__
 *
 * To run a query within a React component, call `useTravelReservationSummariesByPropertyIdentifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelReservationSummariesByPropertyIdentifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelReservationSummariesByPropertyIdentifiersQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelReservationSummariesByPropertyIdentifiersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<TravelReservationSummariesByPropertyIdentifiersQuery, TravelReservationSummariesByPropertyIdentifiersQueryVariables>,
) {
  return ApolloReactHooks.useQuery<TravelReservationSummariesByPropertyIdentifiersQuery, TravelReservationSummariesByPropertyIdentifiersQueryVariables>(
    TravelReservationSummariesByPropertyIdentifiersDocument,
    baseOptions,
  );
}
export function useTravelReservationSummariesByPropertyIdentifiersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelReservationSummariesByPropertyIdentifiersQuery, TravelReservationSummariesByPropertyIdentifiersQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<TravelReservationSummariesByPropertyIdentifiersQuery, TravelReservationSummariesByPropertyIdentifiersQueryVariables>(
    TravelReservationSummariesByPropertyIdentifiersDocument,
    baseOptions,
  );
}
export type TravelReservationSummariesByPropertyIdentifiersQueryHookResult = ReturnType<typeof useTravelReservationSummariesByPropertyIdentifiersQuery>;
export type TravelReservationSummariesByPropertyIdentifiersLazyQueryHookResult = ReturnType<typeof useTravelReservationSummariesByPropertyIdentifiersLazyQuery>;
export type TravelReservationSummariesByPropertyIdentifiersQueryResult = Apollo.QueryResult<
  TravelReservationSummariesByPropertyIdentifiersQuery,
  TravelReservationSummariesByPropertyIdentifiersQueryVariables
>;
export const TravelRateComparisonsForTravelPlacesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TravelRateComparisonsForTravelPlaces' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ComparisonsForTravelPlaceIdPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelRateComparisonsForTravelPlaces' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PriceComparison' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PriceComparison' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelPlaceComparison' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'providers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'providerFQDN' } },
                { kind: 'Field', name: { kind: 'Name', value: 'providerSearchURL' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTravelRateComparisonsForTravelPlacesQuery__
 *
 * To run a query within a React component, call `useTravelRateComparisonsForTravelPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelRateComparisonsForTravelPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelRateComparisonsForTravelPlacesQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelRateComparisonsForTravelPlacesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>,
) {
  return ApolloReactHooks.useQuery<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>(
    TravelRateComparisonsForTravelPlacesDocument,
    baseOptions,
  );
}
export function useTravelRateComparisonsForTravelPlacesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>(
    TravelRateComparisonsForTravelPlacesDocument,
    baseOptions,
  );
}
export type TravelRateComparisonsForTravelPlacesQueryHookResult = ReturnType<typeof useTravelRateComparisonsForTravelPlacesQuery>;
export type TravelRateComparisonsForTravelPlacesLazyQueryHookResult = ReturnType<typeof useTravelRateComparisonsForTravelPlacesLazyQuery>;
export type TravelRateComparisonsForTravelPlacesQueryResult = Apollo.QueryResult<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>;
